module.exports = __webpack_public_path__ + "img/home_bg_banner2.afc82b45.png";